import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]交易-买指数-根据指数查配置-场内-列表
 */
export function getProdByIndexUsingPOST(
  req: EtfassociationParam | void,
  config?: RequestConfig
): Promise<ApiResultInvestTargetCriterionResponse> {
  return resource.postNoAuth('/lcIndex/getETFProdByIndex', req, config);
}

/**
 * [No Auth]交易-买指数-根据指数查配置-场内-limit 1
 */
export function getProdByIndexOneUsingPOST(
  req: EtfassociationParam | void,
  config?: RequestConfig
): Promise<ApiResultInvestTargetCriterionResponse> {
  return resource.postNoAuth('/lcIndex/getETFProdByIndexOne', req, config);
}

/**
 * [No Auth]交易-买指数-根据指数查配置-场外-列表
 */
export function getOffProdByIndexUsingPOST(
  req: EtfassociationParam | void,
  config?: RequestConfig
): Promise<ApiResultLcIndexOffProdResponse> {
  return resource.postNoAuth('/lcIndex/getOffProdByIndex', req, config);
}

/**
 * [No Auth]交易-买指数-查ETF实时行情
 */
export function getStockInfoUsingPOST(
  req: OrderlyStockDto | void,
  config?: RequestConfig
): Promise<ApiResultListStockInfoOrderly> {
  return resource.postNoAuth('/lcIndex/getStockInfo', req, config);
}
